var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-popover',_vm._b({attrs:{"placement":"top","trigger":"hover"}},'el-popover',_vm.attribute,false),[_c('shadow-dom',{attrs:{"content":_vm.content()}}),_c('shadow-dom',{attrs:{"slot":"reference","content":_vm.content()},slot:"reference"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }